import type { RoadmapResponse } from './types'

const API_URL = import.meta.env.VITE_ROADMAP_API_URL || '/api/roadmap.php'

export async function loadRoadmaps(slug?: string): Promise<RoadmapResponse> {
  const url = new URL(API_URL, window.location.origin)
  if (slug) url.searchParams.set('app', slug)
  const accessKey = new URLSearchParams(window.location.search).get('key')
  if (slug && accessKey) url.searchParams.set('key', accessKey)
  const response = await fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } })
  if (!response.ok) throw new Error(response.status === 401 ? 'Login er påkrævet.' : 'Roadmap-data kunne ikke hentes.')
  return response.json() as Promise<RoadmapResponse>
}

export async function login(email: string, password: string): Promise<void> {
  const response = await fetch('/api/login.php', {
    method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  })
  if (!response.ok) throw new Error('Forkert e-mail eller adgangskode.')
}
